import React from 'react';
import './title.scss';
import Carousel from  're-carousel'; // react-responsive-carousel';
import IndicatorDots from './re-carosel/src/indicator-dots';
import Buttons from './re-carosel/src/buttons';
import { Link } from 'react-router-dom';
import { umoksType } from '../../types/types.js';
// import 'react-responsive-carousel/lib/styles/main.css';

// carousel styles
// import 'react-responsive-carousel/lib/styles/carousel.css';

class Title extends React.Component {
  constructor(props) {
    super(props);
  };

  componentWillMount() {};

  getCarosel = () => {
    return (
      <Carousel loop auto widgets={[ IndicatorDots ]} >
        <div className='title-content-wrap'>
          <h2 className='title-h2-new'><b>Шановні споживачі Газ АП!</b></h2>
          <p><h2 className='title-h2-new'><i>Ціна для Вас в лютому 2021 знижена та становитиме<b style={{color: 'red'}}> 6,94 грн. </b>за 1 м<sup>3</sup> <br/> </i> </h2></p>
          <p className='title-p1'>Компанія забезпечує виконання своїх зобов’язань перед існуючими клієнтами за укладеними договорами. </p>
        </div>
        <div  className='title-content-wrap'>
          <h2 className='title-h2-new'><b>Шановні жителі Херсонщини!</b></h2>
          <p className='title-p1'>З <b>19.01.2021</b> компанія Газ АП <b>тимчасово</b> зупиняє приймання заяв-приєднань у точках контакту та на своєму офіційному веб-сайті.</p>
          <p className='title-p1'><b>Всі</b> заяви-приєднання, подані у термін по <b>18.01.2021</b> року будуть опрацьовані нашими фахівцями не пізніше <b>25.01.2021 року</b>, про що буде персонально повідомлено заявників.</p>
          <p className='title-p1'><b>Якщо Ви бажаєте стати клієнтом Газ АП після відновлення приймання заяв, заповніть <a href="https://forms.gle/c929xcJDY9upqp5P8" target="_blank">ФОРМУ</a> та очікуйте на дзвінок нашого фахівця.</b><br/></p>
          <p className='title-p1'> Таке рішення є вимушеним кроком, що продиктований політичним рішенням держави, в частині обмеження конкуренції на ринку природного газу, через введення державної регульованої ціни. <a href='https://www.kmu.gov.ua/news/vstanovlennya-granichnoyi-cini-na-gaz-znizit-jogo-vartist-dlya-naselennya-v-serednomu-na-30-premyer-ministr' target="_blank"> Детальніше за посиланням.</a> </p>
        </div>
      </Carousel>
    );
  };

  render() {
    return (
      <section className='title-wrap f-center' style={{height: 'max-content'}}>
    {/*  <section className='title-wrap f-center' style={{height: 100 + 'vh'}}> */}
        <div className='title-fone' />
        <div className='f-container title-carosel'>
          {/*this.getCarosel()*/}
          <div  className='title-content-wrap'>
            {/*20230427*/}
            <h2 className='title-h2-new'>Для повернення помилково сплачених коштів необхідно надіслати на пошту <a style={{color: 'yellow'}} href="mailto:office.gasup@gmail.com">office.gasup@gmail.com</a></h2>
            <p className='title-h2-new'>Заяву на повернення цих коштів на ім'я директора (Дембіцька О.А.),<br/>  квитанцію про оплату, ідентифікаційний код, <br/>документи, що посвідчують особу платника <br/> та рахунок ІВАN карти на яку будуть повернуті кошти.</p>

            {/*20220810
            <h2 className='title-h2-new'><b style={{color: 'yellow'}}>Шановні споживачі!</b></h2>
            <p className='title-p1 p1-center'> Наразі компанія "Газ АП" не працює, не приймає відвідувачів <br/> та не надає консультацій в телефонному режимі.</p>
            <p className='title-p1 p1-center'> В зв'язку з військовим станом в Україні повернення надлишково/помилково сплачених коштів<br/> на користь ТОВ "Газ АП" не відбувається.</p>
            <p className='title-p1 p1-center'> Дякуємо за розуміння!</p>
            */}
            {/* <p className='title-p1 p1-center'> <Link to = '/home/category/company/news/20220810'><button className='btn-reg'>ДІЗНАТИСЬ БІЛЬШЕ</button></Link></p>

            <h2 className='title-h2-new'><b style={{color: 'yellow'}}>Шановні споживачі!</b></h2>
            <p className='title-p1 p1-center'><b style={{color: 'red'}}><u>22.02.2022</u></b> прийом дзвінків та абонентів відбувається з 13:00-18:00.<br/>Дякуємо за розуміння!</p>
            ---20220222---
            <h2 className='title-h2-new'><b style={{color: 'yellow'}}>Шановні споживачі!</b></h2>
            <p className='title-p1 p1-center'>Звертаємо Вашу увагу на зміну графіку роботи компанії,<br/> для консультацій в телефонному режимі та відвідування контакт центру.</p>
            <p className='title-p1 p1-center'><b style={{color: 'yellow'}}>Прийомний день:</b> <u>Вівторок, з 09:00 до 15:00</u>,<br/> обідня перерва з 12:00 до 13:00.<br/>Телефон: +38(063) 616-13-52.</p>

            <h2 className='title-h2 h2-heigline1'><b style={{color: 'yellow'}}>Шановні споживачі!</b></h2>
            <p className='title-p1 p1-center'>Доводимо до Вашого відома, <b style={{color: 'red'}}>що 20 серпня 2021 року</b> набрав чинності <br/>Закон України від 15.07.2021 № 1657-ІХ, яким було скасовано підпункт 5 пункту 3 розділу ІІ Закону України «Про внесення змін до деяких законодавчих актів України, спрямованих на запобігання виникненню і поширенню коронавірусної хвороби (COVID-19)»</p>
            <p className='title-p1 p1-center'> <Link to = '/home/category/company/news/20210828'><button className='btn-reg'>ДІЗНАТИСЬ БІЛЬШЕ</button></Link> </p>
            */}
            {/* commit 31.08.2021  Режим роботи: Пн. – Пт. з 08:00 до 17:00; прийом споживачів до 15:00, обідня перерва з 12:00 до 13:00
            <h2 className='title-h2 h2-heigline1'><b style={{color: 'yellow'}}>Шановні споживачі!</b></h2>
            <p className='title-p1 p1-warning'>Інформуємо вас що ТОВ  “Газ АП” припиняє постачання природного газу побутовим споживачам з <b style={{color: 'red'}}>01.07.21 року.</b></p>
            <p className='title-p1 p1-center'> <Link to = '/home/category/company/news/20210604'><button className='btn-reg'>ДІЗНАТИСЬ БІЛЬШЕ</button></Link> </p>

             new 19.08.2021
            <p className='title-p1 p1-center'><i><b style={{color: 'yellow'}}>Тариф "Місячний", </b></i>Ціна: <b style={{color: 'red'}}>7,99 грн. </b>за 1 м<sup>3</sup><br/> <b>Термін дії: <u>01.06.2021 - 30.06.2021</u></b></p>
            <p className='title-p1 p1-center'><i><b style={{color: 'yellow'}}>Тариф "Річний", </b></i>Ціна: <b style={{color: '#ffa500'}}>9,99 грн. </b>за 1 м<sup>3</sup><br/> <b>Термін дії: <u>01.05.2021 - 30.04.2022</u></b></p>
                old 31.04.2021
              <h2 className='title-h2-new'><b style={{color: 'yellow'}}>Шановні споживачі “Газ Ап”!</b></h2>
            <p className='title-p1 '> З 01 травня 2021 року всі споживачі автоматично будуть підключені до тарифного плану “Річний” згідно постанови Національної комісії, що здійснює державне регулювання у сферах енергетики та комунальних послуг № 572 від 07.04.2021.</p>
            <p className='title-p1 p1-center'> <Link to = '/home/category/company/news'><button className='btn-reg'>ДІЗНАТИСЬ БІЛЬШЕ</button></Link> </p>
            */}
            {/* <h2 className='title-h2-new'><i><b style={{color: 'yellow'}}>Тариф "Річний" </b></i></h2>
            <p className='title-p1 p1-center'>Ціна: <b style={{color: '#ffa500'}}>9,99 грн. </b>за 1 м<sup>3</sup></p>
            <p className='title-p1 p1-center'><b>Термін дії: <u>01.05.2021 - 30.04.2022</u></b></p><br/>
            <h2 className='title-h2-new'><i><b style={{color: 'yellow'}}>Тариф "Місячний" </b></i></h2>
            <p className='title-p1 p1-center'> Ціна: <b style={{color: 'red'}}>7,99 грн. </b>за 1 м<sup>3</sup> </p>
            <p className='title-p1 p1-center'><b>Термін дії: <u>01.05.2021 - 31.05.2021</u></b></p>

            <h2 className='title-h2-new'><i>Ціна в квітні 2021 року становить <b style={{color: 'red'}}> 7,60 грн. </b>за 1 м<sup>3</sup> <br/> </i></h2><br/>
            <h2 className='title-h2-new'><b>Шановні жителі Херсонщини!</b></h2>
             <p className='title-p11'>Компанія "Газ АП" забезпечує виконання своїх зобов’язань перед існуючими клієнтами за укладеними договорами з постачання природного газу.</p>
            <p className='title-p1 p1-center'><i>Ціна в квітні 2021 року становить <b style={{color: 'red'}}> 7,60 грн. </b>за 1 м<sup>3</sup> <br/> </i></p>*/}

          </div>
        </div>
      </section>
    );
  };
};

Title.propTypes = {
  menuList:  umoksType.isRequired
};

export default Title;



// WEBPACK FOOTER //
// ./src/client/components/title/title.jsx